import React, { useEffect, useRef } from 'react';
import '../styles/faq.css'; // Make sure to import the CSS file

const faqs = [
  {
    question: "What is digital marketing?",
    answer: "Digital marketing uses online channels like social media, search engines, email, and websites to promote products and services."
  },
  {
    question: "Why is digital marketing important for my business?",
    answer: "It helps you reach a wider audience, engage customers directly, and track measurable results, unlike traditional marketing."
  },
  {
    question: "How long does it take to see results?",
    answer: "It depends on the strategy. Paid ads can bring immediate traffic, while SEO and organic growth usually take 3-6 months."
  },
  {
    question: "What services are included in digital marketing?",
    answer: "Our services include SEO, Google Ads, social media marketing, email campaigns, content marketing, and more."
  },
  {
    question: "Do I need a large budget for digital marketing?",
    answer: "Not necessarily. We tailor strategies to fit your budget, ensuring the best ROI whether small or large."
  },
  {
    question: "Can you guarantee results?",
    answer: "We guarantee effort, strategy, and reporting. While no one can promise exact results, we ensure consistent growth and optimization."
  }
];

const DigitalMarketingFAQs = () => {


       const servicesRef = useRef(null);
          
       useEffect (() => {
        const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
         const scrollReveal = () => {
            for (let i = 0; i < revealElements.length; i++) {
             const elementIsInScreen =
            revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
          
          if (elementIsInScreen) {
           revealElements[i].classList.add("revealed");
           } else {
              revealElements[i].classList.remove("revealed");
               }
            }
           };
          
           window.addEventListener("scroll", scrollReveal);
              scrollReveal(); // Initial check
          
              return () => {
                window.removeEventListener("scroll", scrollReveal);
              };
            }, []);
  

  return (
    <section className="faq-section" ref={servicesRef}>
      <h2 className="faq-title" data-reveal>Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-item" data-reveal key={index}>
            <h3 className="faq-question">{item.question}</h3>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DigitalMarketingFAQs;
